import { createSelector, createSlice } from '@reduxjs/toolkit';
import { memoize, sortBy } from 'lodash';
import { selectAllObjects } from './objectsSlice';
import { selectAllProperties } from './propertiesSlice';

const initialState = {
	all: null,
};

const foldersSlice = createSlice({
	name: 'folders',
	initialState,
	reducers: {
		setFolders: (state, action) => {
			if (action.payload) {
				state.all = action.payload.folders;
			}
		},
		resetFolders: (state) => {
			state.all = initialState.all;
		},
	},
});

export default foldersSlice.reducer;
export const { setFolders, resetFolders } = foldersSlice.actions;


export const selectFolders = (state) => state.folders.all;
export const selectFolderById = (state, folderId) => state.folders.all?.[folderId];

export const selectFoldersByIds = (state, folderIds) => {
	if (!folderIds) {
		return null;
	}
	const folders = folderIds.map((folderId) => state.folders.all?.[folderId]);
	return folders;
};

export const selectFolderByIdWithObjectsAndProperties = createSelector(
	selectFolderById,
	selectAllObjects,
	selectAllProperties,
	memoize((folder, allObjects, allProperties) => {
		if (folder) {
			const objectsOfFolder = folder?.objects && allObjects ? folder?.objects.map((objId) => allObjects[objId]).filter((entry) => typeof entry !== 'undefined' && entry !== null) : [];
			const propertyIdsOfObjects = objectsOfFolder?.map((object) => object.properties);
			const flatPropertiesOfObjects = propertyIdsOfObjects?.reduce((a, b) => a.concat(b), []);
			const propertyIdsOfObjectsWithoutDuplicates = [...new Set(flatPropertiesOfObjects)];
			const propertiesOfFolder = propertyIdsOfObjectsWithoutDuplicates.map((propertyId) => allProperties?.[propertyId]);
			const sortedPropertiesOfFolder = sortBy(propertiesOfFolder, ['position']);

			return { ...folder, realObjects: objectsOfFolder, properties: sortedPropertiesOfFolder, propertyIds: propertyIdsOfObjectsWithoutDuplicates };
		}
		return null;
	}),
);
